class DharmaModalTriggerButton extends HTMLButtonElement {
  #abortController
  #modal

  constructor() {
    super();
  }

  disconnectedCallback() {
    this.#removeListeners();
  }

  static get observedAttributes() {
    return ['data-modal-id'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-modal-id') {
      this.#removeListeners();
      this.#modal = document.querySelector(`dharma-modal[id="${newValue}"]`);
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;
      this.addEventListener('click', () => this.#modal.dataset.show = 'true', { signal });
    }
  }

  #removeListeners() {
    if (this.#abortController) {
      this.#abortController.abort();
      this.#abortController = null;
    }
  }

}

customElements.define('dharma-modal-trigger-button', DharmaModalTriggerButton, { extends: 'button' });